import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { useTranslation, initReactI18next } from 'react-i18next';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox, faCompass, faEdit, faLink, faEyeSlash } from '@fortawesome/pro-light-svg-icons';

import './Amphi.sass';
import { faCircle, faSquare } from '@fortawesome/pro-solid-svg-icons';
import { Tooltip } from 'antd';

const rotate = (
	cx: number,
	cy: number,
	x: number,
	y: number,
	angle: number
) => {
	var radians = (Math.PI / 180) * angle,
		cos = Math.cos(radians),
		sin = Math.sin(radians),
		nx = cos * (x - cx) + sin * (y - cy) + cx,
		ny = cos * (y - cy) - sin * (x - cx) + cy;
	return [nx, ny];
};

let actions = [
	{
		item: (
			<g className="medium">
				<FontAwesomeIcon icon={faSquare} color="#BBBBBB" />
			</g>
		),
		action: 'impact',
		value: 'medium',
		placement: 'right',
		label: 'models.item.fields.impact.level.medium'
	},
	{
		item: (
			<g className="big">
				<FontAwesomeIcon icon={faSquare} color="#BBBBBB" />
			</g>
		),
		action: 'impact',
		value: 'high',
		placement: 'top',
		label: 'models.item.fields.impact.level.high'
	},
	{
		item: <FontAwesomeIcon color="#00B0A9" icon={faCircle} />,
		action: 'trend',
		value: 'green',
		placement: 'top',
		label: 'models.item.fields.trend.level.green'
	},
	{
		item: <FontAwesomeIcon color="#DDDDDD" icon={faCircle} />,
		action: 'trend',
		value: 'neutral',
		placement: 'left',
		label: 'models.item.fields.trend.level.neutral'
	},
	{
		item: <FontAwesomeIcon color="#FCC356" icon={faCircle} />,
		action: 'trend',
		value: 'orange',
		placement: 'left',
		label: 'models.item.fields.trend.level.orange'
	},

	{
		item: (
			<FontAwesomeIcon className="big" color="#E70549" icon={faCircle} />
		),
		action: 'trend',
		value: 'red',
		placement: 'left',
		label: 'models.item.fields.trend.level.red'
	},
	{
		item: <FontAwesomeIcon icon={faEdit} color="#BBBBBB" />,
		action: 'edit',
		placement: 'bottom',
		description: 'actions.edit'
	},
	{
		item: <FontAwesomeIcon icon={faLink} color="#BBBBBB" />,
		action: 'link',
		placement: 'bottom',
		description: 'models.item_link.actions.create_new'
	},
	{
		item: <FontAwesomeIcon icon={faEyeSlash} color="#BBBBBB" />,
		action: 'disable',
		placement: 'bottom',
		description: 'actions.disable'
	},
	{
		item: (
			<g className="small">
				<FontAwesomeIcon icon={faSquare} color="#BBBBBB" />
			</g>
		),
		action: 'impact',
		value: 'low',
		placement: 'right',
		label: 'models.item.fields.impact.level.low'
	}
];
let [startX, startY, width] = [30, 0, 75];
let delta = 1.5;

const getCoordinates = (
	startX: number,
	endX: number,
	angle: number,
	delta: number
) => {
	let [xOutside, yOutside] = rotate(0, 0, endX, 0, angle);
	let [xInside, yInside] = rotate(0, 0, startX, 0, angle);

	let [xInsideRight, yInsideRight] = rotate(
		xOutside,
		yOutside,
		xInside,
		yInside,
		delta
	);
	let [xInsideLeft, yInsideLeft] = rotate(
		xOutside,
		yOutside,
		xInside,
		yInside,
		-delta
	);

	let [xOutsideLeft, yOutsideLeft] = rotate(
		xInside,
		yInside,
		xOutside,
		yOutside,
		delta
	);
	let [xOutsideRight, yOutsideRight] = rotate(
		xInside,
		yInside,
		xOutside,
		yOutside,
		-delta
	);

	return {
		xOutside,
		yOutside,
		xInside,
		yInside,

		xInsideRight,
		yInsideRight,
		xInsideLeft,
		yInsideLeft,
		xOutsideLeft,
		yOutsideLeft,
		xOutsideRight,
		yOutsideRight
	};
};

export function Amphi(props: any) {
	const [opened, setOpened] = React.useState<true | false>(true);

	const { t } = useTranslation();

	if (!props.visible || !props.selection) return null;
	return (
		<div
			id="Amphi"
			style={{
				transform: 'translate( ' + props.x + 'px, ' + props.y + 'px )'
			}}
			className={props.visible ? 'visible' : ''}
		>
			<svg
				style={{ width: '200px', height: '200px' }}
				viewBox="-100 -100 200 200"
			>
				<circle
					x="0"
					y="0"
					r="28"
					fill="#FFFFFF00"
					onClick={() => props.onDismiss()}
				></circle>

				{actions.map((a, index) => {
					let startAngle = (index / actions.length) * 360;
					let midAngle = ((index + 0.5) / actions.length) * 360;
					let endAngle = ((index + 1) / actions.length) * 360;

					let coordinatesCurrent = getCoordinates(
						startX,
						width,
						startAngle,
						delta
					);
					let coordinatesNext = getCoordinates(
						startX,
						width,
						endAngle,
						delta
					);

					let [x, y] = rotate(0, 0, width - startX + 8, 0, midAngle);

					return (
						<Tooltip title={a.description ? `${t(a.description)}` : `${t('models.item.fields.' + a.action + '.label')}: ${t(a.label)}`} placement={a.placement}>
							<g
								className={[
									'sliceWrapper',
									a.action &&
										props.selection &&
										props.selection[a.action] &&
										props.selection[a.action] == a.value
										? 'selected'
										: ''
								].join(' ')}
								key={a.value ? `${a.action}-${a.value}` : a.action}
								id={a.value ? `${a.action}-${a.value}` : a.action}
								onClick={() => props.onChange(a.action, a.value)}
							>
								{

									<path
										className="slice"
										fill="#363D4D"
										d={[
											[
												'M' +
												coordinatesCurrent.xInsideLeft,
												coordinatesCurrent.yInsideLeft
											].join(' '),

											[
												'A',
												startX,
												startX,
												1,
												0,
												0,
												coordinatesNext.xInsideRight,
												coordinatesNext.yInsideRight
											].join(' '),

											[
												'L' + coordinatesNext.xOutsideRight,
												coordinatesNext.yOutsideRight
											].join(' '),

											// Arc
											[
												'A',
												width,
												width,
												0,
												0,
												1,
												coordinatesCurrent.xOutsideLeft,
												coordinatesCurrent.yOutsideLeft
											].join(' '),

											'Z'
										].join(' ')}
									></path>
								}{' '}


								<g
									className="action"
									transform={`translate(${x - 10}, ${y - 10}) scale(0.1) `}
								>
									{a.item}
								</g>

							</g>
						</Tooltip>
					);
				})}
			</svg>
		</div>
	);
}
